import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonContentsRenderType, type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";
import { V2EventCreateRequestDtoCategory, V2NoticeCreateRequestDtoCategory } from "@everon-it/api-client/contents-gw";
import { DateUtil } from "@everon-it/core";

export type NoticeCreateInitValuesType = {
    category: V2NoticeCreateRequestDtoCategory;
    title: string;
    isVisible: boolean;
    isPinned: boolean;
    displayStartAt: string;
    displayEndAt: string;
    contentCategory: V2EventCreateRequestDtoCategory;
    content: string;
};

export type NoticeCommonContentsOptionType = {
    secondName?: string;
    placeholder?: string;
    secondPlaceholder?: string;
} & CommonContentsRenderType;

export const NoticeCreateData: CommonDataType<CommonCreateBodyKeyType, NoticeCreateInitValuesType, NoticeCommonContentsOptionType> = {
    createBodyKey: ["category", "title", "isVisible", "isPinned", "displayStartAt", "displayEndAt", "content"],
    formInitialValues: {
        category: V2NoticeCreateRequestDtoCategory.GENERAL,
        title: "",
        isVisible: false,
        isPinned: false,
        displayStartAt: DateUtil.getToday(),
        displayEndAt: "",
        contentCategory: V2EventCreateRequestDtoCategory.CONTENT,
        content: "",
    },
    contentsOption: [
        {
            label: "게시 유형",
            name: "category",
            type: CommonElementType.RADIO,
            options: [
                { label: "공지(충전서비스)", value: V2NoticeCreateRequestDtoCategory.GENERAL },
                { label: "투자정보", value: V2NoticeCreateRequestDtoCategory.IR },
            ],
        },
        {
            label: "게시 기간",
            type: CommonElementType.DATE_RANGE_PICKER,
            name: "displayStartAt",
            secondName: "displayEndAt",
            placeholder: "날짜를 입력해주세요",
            secondPlaceholder: "날짜를 입력해주세요",
        },
        {
            label: "노출 상태",
            name: "isVisible",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "상단 고정 여부",
            name: "isPinned",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "제목",
            name: "title",
            type: CommonElementType.INPUT,
            placeholder: "제목을 입력해주세요",
        },
    ],
};
